import axios from 'axios'
import authHeader from './auth-header'
// import moment from 'moment'

class NegociaService {
  getPoliticas () {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politicas/0`, { headers: authHeader() })
  }

  getPolitica ( idPolitica ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politica/${idPolitica}`, { headers: authHeader() })
  }

  getCampanhas () {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politicas/1`, { headers: authHeader() })
  }

}

export default new NegociaService()